import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { baseApi } from 'api/baseApi.ts';
import { getCommonMiddleware } from 'core/store/middleware';
import transforms, { getNewDefaultState } from 'core/store/persist-reducer-transforms';
import { canvasReducers, desktopReducers, webReducers } from 'core/store/reducers';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist-indexeddb-storage';
import hardSet from 'redux-persist/es/stateReconciler/hardSet';
// import storage from 'redux-persist/lib/storage';

const persistConfig = {
	key: 'root',
	// storage,
	storage: storage('appData'),
	whitelist: [
		'studio',
		'canvas',
		'assets',
		'characterStudio',
		'home',
		'app',
		'profile',
		'intermediateMedia',
		'api',
	],
	deserialize: false,
	serialize: false,
	stateReconciler: hardSet,
	transforms,
	// Version control for migrations
	version: 4,
	migrate: (state, version) => {
		// eslint-disable-next-line no-underscore-dangle
		if (state?._persist.version !== version) {
			return Promise.resolve({
				...state,
				...getNewDefaultState(),
			});
		}
		return Promise.resolve(state);
	},
};

const createStoreConfig = (reducers, additionalMiddleware = []) => ({
	reducer: persistReducer(persistConfig, combineReducers(reducers)),
	middleware: (getDefaultMiddleware) => {
		const commonMiddleware = getCommonMiddleware(getDefaultMiddleware).concat(baseApi.middleware);
		return additionalMiddleware.length
			? commonMiddleware.concat(additionalMiddleware)
			: commonMiddleware;
	},
	devTools: process.env.NODE_ENV !== 'production',
});

export const createWebStore = (additionalReducers = {}, additionalMiddleware = []) =>
	configureStore(
		createStoreConfig({ ...webReducers, ...additionalReducers }, additionalMiddleware),
	);

export const createDesktopStore = (additionalReducers = {}, additionalMiddleware = []) =>
	configureStore(
		createStoreConfig({ ...desktopReducers, ...additionalReducers }, additionalMiddleware),
	);

export const createCanvasStore = (additionalReducers = {}, additionalMiddleware = []) =>
	configureStore(
		createStoreConfig({ ...canvasReducers, ...additionalReducers }, additionalMiddleware),
	);
